<div style="background: #f8f8f8">
  <dxo-tabs
    [dxoDataset]="[
      {
        selector: '.tablinks:nth-child(1)',
        data: { e2e: 'claims-tab' }
      },
      {
        selector: '.tablinks:nth-child(2)',
        data: { e2e: 'employee-tab' }
      },
      {
        selector: '.tablinks:nth-child(3)',
        data: { e2e: 'tax-tab' }
      }
    ]"
  >
    <dxo-tab [header]="'Claim'" [templateRef]="claimsTab" />
    <dxo-tab [header]="'Employee'" [templateRef]="employeeTab" />
    <dxo-tab [header]="'Tax'" [templateRef]="taxTab" />
  </dxo-tabs>
</div>
<ng-template #claimsTab>
  <app-claims-page />
</ng-template>
<ng-template #employeeTab>
  <app-employeeforms-page />
</ng-template>
<ng-template #taxTab>
  <app-taxforms-page />
</ng-template>
